// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"70":"1dd59278","706":"e68c2b70","890":"f8b686d7","968":"e6b4a508"}[chunkId] + ".js";
};